import { render } from "./OutletDetails.vue?vue&type=template&id=ff84cbc2"
import script from "./OutletDetails.vue?vue&type=script&lang=js"
export * from "./OutletDetails.vue?vue&type=script&lang=js"

import "./OutletDetails.vue?vue&type=style&index=0&id=ff84cbc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__